import React from 'react';
import Modal from 'containers/Modal/Modal';
import { clearModal } from 'actions/modals/';
import { updateQuantity } from 'actions/item/';
import { ITEM_QUANTITY_MODAL } from 'constants/modal';
import { useDispatch, useSelector } from 'react-redux';
import { Quantity, Attribute, Condition } from 'components/Item/';

export default function ItemQuantityModal() {
  const dispatch = useDispatch();
  const modal = useSelector(({ modal }) => modal);
  const isOpen = modal?.type === ITEM_QUANTITY_MODAL;
  const {
    id = '',
    item = {},
    statuses = [],
    companyId = '',
    conditions = [],
    maxQuantity = 0,
    conditionId = '',
    isOnBoarding = false,
    hasCondition = false,
  } = isOpen && modal?.initialValue;
  let component = (
    <Quantity
      id={id}
      onSubmit={onSubmit}
      stock={item.quantity}
      onClose={onModalClose}
      maxQuantity={maxQuantity}
    />
  );
  const hasAttributes = item.attributes && item.attributes.length > 0;

  function onModalClose() {
    dispatch(clearModal(ITEM_QUANTITY_MODAL));
  }

  function onSubmit(payload) {
    dispatch(updateQuantity(payload));
  }

  if (hasCondition) {
    component = (
      <Condition
        id={id}
        isUpdatingQuantity
        onSubmit={onSubmit}
        itemName={item.name}
        stock={item.quantity}
        companyId={companyId}
        conditions={conditions}
        maxQuantity={maxQuantity}
        conditionId={conditionId}
        isOnBoarding={isOnBoarding}
        onModalClose={onModalClose}
        attributes={item.attributes}
      />
    );
  }

  if (hasAttributes) {
    component = (
      <Attribute
        id={id}
        isUpdatingQuantity
        statuses={statuses}
        onSubmit={onSubmit}
        itemName={item.name}
        stock={item.quantity}
        companyId={companyId}
        maxQuantity={maxQuantity}
        onModalClose={onModalClose}
        isOnBoarding={isOnBoarding}
        attributes={item.attributes}
      />
    );
  }

  return (
    <Modal
      modalTop={5}
      modalLeft={30}
      isOpen={isOpen}
      modalWidth={40}
      onClose={onModalClose}
      caption="Update Item Quantity"
    >
      {component}
    </Modal>
  );
}
